var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1084 4.43945H18.8914",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8291 5.93945C5.65753 5.93945 6.3291 5.26788 6.3291 4.43945C6.3291 3.61103 5.65753 2.93945 4.8291 2.93945C4.00067 2.93945 3.3291 3.61103 3.3291 4.43945C3.3291 5.26788 4.00067 5.93945 4.8291 5.93945Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1084 10.7365H18.8914",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2031 12.2365C16.0316 12.2365 16.7031 11.5649 16.7031 10.7365C16.7031 9.90802 16.0316 9.23645 15.2031 9.23645C14.3747 9.23645 13.7031 9.90802 13.7031 10.7365C13.7031 11.5649 14.3747 12.2365 15.2031 12.2365Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1084 17.0332H18.8914",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0166 18.5332C10.845 18.5332 11.5166 17.8616 11.5166 17.0332C11.5166 16.2048 10.845 15.5332 10.0166 15.5332C9.18817 15.5332 8.5166 16.2048 8.5166 17.0332C8.5166 17.8616 9.18817 18.5332 10.0166 18.5332Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeWidth: 2
  })));
};
export default SvgFilter;